import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '70vh',
    flexDirection: 'column',
    width: '100%',
  },

  loadingText: {
    marginTop: 20,
    fontSize: 18,
  },
}))

export default styles
